// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'smallfoot',
  heroImg: 'hero.jpg',
  heroTheme: 'light',
  heroHeadingOne: 'Warner Bros',
  heroHeadingTwo: 'Smallfoot',
  details: [
    {
      title: 'AGENCY',
      items: ['Psycle'],
    },
    {
      title: 'PLATFORM',
      items: ['Dialogflow', 'Firebase', 'Google Assistant'],
    },
    {
      title: 'LAUNCH',
      items: ['September 2018'],
    },
  ],
  heading: 'An interactive journey into the secret world of yetis',
  challengeImg: 'challenge.png',
  challenge: false,
  footerImg: false,
  solution: [
    'A Google Assistant Action created to celebrate the launch of Smallfoot, a major animated movie from Warner Bros.',
    'Users are welcomed by the characters, taught some yeti, and invited to play a game of Yeti musical statues.',
    'The Action was launched in the UK and the USA, and holds over <strong>70k conversations per month</strong>, with average conversation length being over two and a half minutes.',
  ],
  nextCaseStudy: 'armani-smartwatch',
};

export default casestudyData;
